import React from "react";
import { ShieldCheck } from "lucide-react";

const EUCompliant = () => {
  return (
    <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 py-24 text-center text-white relative overflow-hidden">

      {/* Background decorations — mirrored from CTASection */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/2 translate-y-1/2 pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-6">

        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium mb-8">
          <ShieldCheck size={15} />
          EU Compliant
        </div>

        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-bold leading-tight">
          EU Regulatory Compliance
        </h2>

        {/* Body */}
        <p className="text-lg text-blue-100 mt-6 max-w-2xl mx-auto leading-relaxed">
          Fully aligned with EU regulatory frameworks.
Aligning with safety protocols, regulatory requirements, and mandatory compliance standards for products distributed across EU markets.
        </p>

      </div>
    </section>
  );
};

export default EUCompliant;